import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { Button } from '@chakra-ui/react'
// import { json } from "react-router-dom";
import { useToast ,Box} from '@chakra-ui/react'
import axios from "axios";
function SingleProduct(){
    const {id} = useParams()
    // console.log(param);
    const toast = useToast()

    const [data,setData] = useState({})
    useEffect(()=>{
        axios.get(`https://wearwave-server.onrender.com/prods/${id}`).then((res)=>{
            setData(res.data)
        }).catch((err)=>console.log(err))
    },[])
    console.log(data);
    let cartData = JSON.parse(localStorage.getItem("cartData")) || []
    function addtocart(product){
        cartData.push(product)
        localStorage.setItem("cartData",JSON.stringify(cartData))
               
        toast({
    
            render: () => (
              <Box color='white' p={3} bg='blue.500'>
                 Product Added To Cart
              </Box>
            )
          })
    }


    return (
        <DIV>
            <div className="img">

<img src={data.image} alt="" />
            </div>
<div className="info">
    <h4>Title: {data.title}</h4>
    <p>Description : {data.description}</p>
    <p>Gender : {data.gender}</p>
    <p>Rating : {data.rating}</p>
    <p>Color: {data.color}</p>
    <p>Price : {data.price}</p>
      <Button style={{backgroundColor:"#ff972c"}} onClick={()=>{addtocart(data)}} colorScheme='blue'>Add To Cart</Button>
</div>
        </DIV>
    )
}
const DIV = styled.div`
margin-top: 20px;
    display: flex;
    justify-content: space-around;
    .img{
        width: 40%;
        padding: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    img{
        /* margin: auto; */
        box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px;
        width: 70%;
        border-radius: 20px;
        
    }
    .info{
        padding: 20px;
        width: 40%;
        height: fit-content;
        box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px; 
    }
    @media (max-width: 480px) {
        flex-direction: column;
        .img{
        width: 60%;
        padding: 20px;
        margin: auto;
        display: flex;
        justify-content: center;
        align-items: center;
         }
         img{
        /* margin: auto; */
        box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px;
        width: 100%;
        border-radius: 20px;
        
        }
        .info{
        padding: 20px;
        width: 80%;
        margin: auto;
        height: fit-content;
        box-shadow: rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px; 
    }
    }

`
export default SingleProduct;